export const dealEduAgentRect = (data, dealItem = true, pageNum = 1) => {
  let groupOptions = [];
  data.QuestionInfo[0]?.ResultList?.map((item, questionId) => {
    let _ItemCoord = item.Coord[0];
    let question = {
      visible: false,
      cantSelect: false,
      fill: 'transparent',
      titleStyle: {
        activeColor: '#4A70FF',
        color: '#4A70FF',
        bgColor:'#F1F6FF',
      },
      activeFill: 'rgba(0, 110, 255, 0.12)',
      stroke: '#AACFFF',
      activeStoke: '#4A70FF',
      label: `题目${questionId + 1}`,
      value: `Question${questionId.toString()}1`,
      key: `Question${questionId.toString()}1`,
      OriginImgHeight: data.QuestionInfo[0].Height,
      OriginImgWidth: data.QuestionInfo[0].Width,
      pageNum: pageNum,
      points: [
        _ItemCoord?.LeftTop?.X || 0, _ItemCoord?.LeftTop?.Y || 0,
        _ItemCoord?.RightTop?.X || 0, _ItemCoord?.RightTop?.Y || 0,
        _ItemCoord?.RightBottom?.X || 0, _ItemCoord?.RightBottom?.Y || 0,
        _ItemCoord?.LeftBottom?.X || 0, _ItemCoord?.LeftBottom?.Y || 0
      ]
    };
    let childrenQuestion = [];
    let QuestionList = item.Question.map(i => i.ResultList).flat(Infinity).filter(item => item != null);
    if (QuestionList?.length > 0 && dealItem) {
      QuestionList.map((item, childId) => {
        let _ItemCoord = item.Coord[0];
        childrenQuestion.push({
          visible: false,
          cantSelect: false,
          titleStyle: {
            activeColor: '#0FB87F',
            color: '#E6F8EF'
          },
          fill: 'transparent',
          activeFill: 'rgba(0, 110, 255, 0.12)',
          stroke: '#AACFFF',
          activeStoke: '#4A70FF',
          label: `子题目${questionId + 1} - ${childId + 1}`,
          type: 'children',
          value: `Question${questionId.toString()}${childId.toString()}2`,
          key: `Question${questionId.toString()}${childId.toString()}2`,
          OriginImgHeight: data.QuestionInfo[0].Height,
          OriginImgWidth: data.QuestionInfo[0].Width,
          pageNum: pageNum,
          points: [
            _ItemCoord?.LeftTop?.X || 0, _ItemCoord?.LeftTop?.Y || 0,
            _ItemCoord?.RightTop?.X || 0, _ItemCoord?.RightTop?.Y || 0,
            _ItemCoord?.RightBottom?.X || 0, _ItemCoord?.RightBottom?.Y || 0,
            _ItemCoord?.LeftBottom?.X || 0, _ItemCoord?.LeftBottom?.Y || 0
          ]
        });
      });
    }
    groupOptions.push({
      group: `题目${questionId + 1}`,
      children: [question, ...childrenQuestion]
    });
  });
  return groupOptions.map(i => i.children).flat();
}

/**
 * 处理 MarkInfos 数据的坐标，生成答案矩形框
 * @param {Object} data - 包含 MarkInfos 的响应数据
 * @param {Object} questionData - QuestionInfo 数据，用于获取图片尺寸
 * @param {number} pageNum - 页面编号（用于多页 PDF 场景）
 * @returns {Array} 矩形框数组
 */
export const dealMarkInfoRect = (data, questionData, pageNum = 1) => {
  let groupOptions = [];
  const markInfos = data?.data?.Response?.MarkInfos || data?.Response?.MarkInfos || data?.MarkInfos || [];
  const questionInfo = questionData?.QuestionInfo?.[0] || data?.data?.Response?.QuestionInfo?.[0] || data?.QuestionInfo?.[0] || {};
  const imgHeight = questionInfo.Height || 0;
  const imgWidth = questionInfo.Width || 0;

  markInfos.forEach((markItem, questionId) => {
    const answerInfos = markItem.AnswerInfos || [];
    let answerRects = [];

    answerInfos.forEach((answer, answerIdx) => {
      // 兼容两种字段名: HandwriteInfoPostions (essay.json) 和 HandwriteInfoPositions
      const positions = answer.HandwriteInfoPostions || answer.HandwriteInfoPositions || [];
      // HandwriteInfoPostions 是 8 个数字的数组：[x1,y1, x2,y2, x3,y3, x4,y4]
      // 顺序为：左上、右上、右下、左下
      if (positions.length === 8) {
        answerRects.push({
          visible: false,
          cantSelect: false,
          IsCorrect: answer.IsCorrect,
          titleStyle: {
            activeColor: '#FF8345',
            color: '#F1F6FF',
            bgColor: '#FFF8F0'
          },
          fill: 'transparent',
          activeFill: 'rgba(0, 110, 255, 0.12)',
          stroke: 'transparent',
          activeStoke: '#4A70FF',
          label: '',
          type: 'answer',
          questionId: questionId,
          answerIdx: answerIdx,
          value: `markInfo${questionId}_${answerIdx}`,
          key: `markInfo${questionId}_${answerIdx}`,
          OriginImgHeight: imgHeight,
          OriginImgWidth: imgWidth,
          pageNum: pageNum,
          points: [
            positions[0], positions[1], // 左上
            positions[2], positions[3], // 右上
            positions[4], positions[5], // 右下
            positions[6], positions[7]  // 左下
          ]
        });
      }
    });

    // 递归处理嵌套的 MarkInfos（子题目）
    const subMarkInfos = markItem.MarkInfos || [];
    subMarkInfos.forEach((subMarkItem, subIdx) => {
      const subAnswerInfos = subMarkItem.AnswerInfos || [];
      subAnswerInfos.forEach((answer, answerIdx) => {
        const positions = answer.HandwriteInfoPostions || answer.HandwriteInfoPositions || [];
        if (positions.length === 8) {
          answerRects.push({
            visible: false,
            cantSelect: false,
            IsCorrect: answer.IsCorrect,
            titleStyle: {
              activeColor: '#0FB87F',
              color: '#E6F8EF',
              bgColor: '#E6F8EF'
            },
            fill: 'transparent',
            activeFill: 'rgba(0, 110, 255, 0.12)',
            stroke: 'transparent',
            activeStoke: '#4A70FF',
            label: '',
            type: 'subAnswer',
            questionId: questionId,
            subIdx: subIdx,
            answerIdx: answerIdx,
            value: `markInfo${questionId}_sub${subIdx}_${answerIdx}`,
            key: `markInfo${questionId}_sub${subIdx}_${answerIdx}`,
            OriginImgHeight: imgHeight,
            OriginImgWidth: imgWidth,
            pageNum: pageNum,
            points: [
              positions[0], positions[1],
              positions[2], positions[3],
              positions[4], positions[5],
              positions[6], positions[7]
            ]
          });
        }
      });
    });

    if (answerRects.length > 0) {
      groupOptions.push({
        group: `题目${markItem.MarkItemTitle || questionId + 1}`,
        children: answerRects
      });
    }
  });

  return groupOptions.map(i => i.children).flat();
}

/**
 * 处理 Essay SentenceSuggests 数据的坐标，生成矩形框
 * @param {Object} data - 包含 SentenceSuggests 的响应数据
 * @param {number} imgHeight - 图片高度
 * @param {number} imgWidth - 图片宽度
 * @param {number} pageNum - 页面编号（用于多页 PDF 场景）
 * @returns {Array} 矩形框数组
 */
export const dealEssayRect = (data, imgHeight = 0, imgWidth = 0, pageNum = 1) => {
  let rectList = [];
  const sentenceSuggests = data?.data?.Response?.SentenceSuggests || data?.Response?.SentenceSuggests || data?.SentenceSuggests || [];

  sentenceSuggests.forEach((item, index) => {
    const positions = item.Position || [];
    
    // Position 是字符串数组，每个字符串格式为 "[x1, y1, x2, y2, x3, y3, x4, y4]"
    positions.forEach((posStr, posIndex) => {
      try {
        // 解析字符串为数组
        const posArray = JSON.parse(posStr);
        if (posArray.length === 8) {
          rectList.push({
            visible: false,
            cantSelect: false,
            titleStyle: {
              activeColor: '#FF8345',
              color: '#FFF8F0',
              bgColor: '#FFF8F0'
            },
            fill: 'transparent',
            activeFill: 'rgba(0, 110, 255, 0.12)',
            stroke: '#AACFFF',
            activeStoke: '#4A70FF',
            label: positions.length > 1 ? `${item.SubType || item.Type}-${posIndex + 1}` : (item.SubType || item.Type),
            type: item.Type,
            subType: item.SubType,
            value: `essay_${index}`,
            key: `essay_${index}`,
            posIndex: posIndex,
            OriginImgHeight: imgHeight,
            OriginImgWidth: imgWidth,
            pageNum: pageNum,
            points: [
              posArray[0], posArray[1], // 左上
              posArray[2], posArray[3], // 右上
              posArray[4], posArray[5], // 右下
              posArray[6], posArray[7]  // 左下
            ]
          });
        }
      } catch (e) {
        console.error('解析 Position 失败:', posStr, e);
      }
    });
  });

  return rectList;
}


export const getPositionRelativeToParent = (element, parent) => {
  const elementRect = element.getBoundingClientRect();
  const parentRect = parent.getBoundingClientRect();
  const computedStyle = getComputedStyle(parent);
  const parentBorderLeft = parseFloat(computedStyle.borderLeftWidth) || 0;
  const parentBorderTop = parseFloat(computedStyle.borderTopWidth) || 0;
  const parentPaddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
  const parentPaddingTop = parseFloat(computedStyle.paddingTop) || 0;

  const scrollLeft = parent.scrollLeft;
  const scrollTop = parent.scrollTop;

  const left = elementRect.left - parentRect.left - parentBorderLeft - parentPaddingLeft + scrollLeft;
  const top = elementRect.top - parentRect.top - parentBorderTop - parentPaddingTop + scrollTop;

  return { left, top };
}

//  TODO： 后期改为konva内置的方法
export const cropToBase64 = (image, points,curImgSize) => {
  return new Promise(async (resolve, reject) => {
  if (!image) resolve("");

  const img = new Image();
  let radio = 1 ;
  let _points = points ;
  img.src = image;
  img.crossOrigin = 'Anonymous';
  img.onload = () => {
      if(curImgSize){
        radio = img.width / curImgSize.width
        _points = _points.map(i => (
          {
          x: i.x * radio,
          y: i.y * radio,
        }
        ))
      }

    // 定义四边形的四个点（示例坐标）
    // const points = [
    //   { x: 100, y: 100 }, // 左上
    //   { x: 300, y: 150 }, // 右上
    //   { x: 280, y: 350 }, // 右下
    //   { x: 80, y: 300 }   // 左下
    // ];

    // 创建离屏 Canvas
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    // 设置 Canvas 尺寸为四边形外接矩形
    const minX = Math.min(..._points.map(p => p.x));
    const maxX = Math.max(..._points.map(p => p.x));
    const minY = Math.min(..._points.map(p => p.y));
    const maxY = Math.max(..._points.map(p => p.y));
    canvas.width = maxX - minX;
    canvas.height = maxY - minY;

    // 创建裁剪路径（四边形）
    ctx.beginPath();
    ctx.moveTo(_points[0].x - minX, _points[0].y - minY);
    _points.forEach(point => {
      ctx.lineTo(point.x - minX, point.y - minY);
    });
    ctx.closePath();
    ctx.clip();
    // 绘制图像（偏移到裁剪区域）
    ctx.drawImage(
      img,
      minX, minY, // 源图像起点
      canvas.width, canvas.height, // 源图像宽高
      0, 0, // 目标起点
      canvas.width, canvas.height // 目标宽高
    );
    // 获取 Base64
    const base64 = canvas.toDataURL('image/png');
    resolve(base64);
  }
  img.onerror = function (err) {
      console.log('任务图片识别失败', err)
      resolve("");
    };
  })
};
